import { App } from '@yleisradio/areena-types/domain/app';
import { hbbTvMode, Mode } from '../../common/types';
import { Control } from '@yleisradio/areena-types';

export const filterSideBarMenuGroupings = (
  appMenu: App | undefined,
  mode: Mode,
  isLoggedIn: boolean
) => {
  const unfilteredGroupings =
    appMenu?.menus.find(menu => menu.tag === 'main')?.groupings ?? [];
  const isHbbtv = mode === hbbTvMode;
  return unfilteredGroupings.map(grouping => ({
    ...grouping,
    controls: grouping.controls.reduce((controls: Control[], control) => {
      const isLiveInHbbtv =
        isHbbtv && control.destination?.uri.includes('live');

      const isValidControl = control.audience
        ? (isLoggedIn && control.audience.authenticated) ||
          (!isLoggedIn && !control.audience.authenticated)
        : !isLiveInHbbtv;

      return isValidControl ? controls.concat(control) : controls;
    }, []),
  }));
};
